<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ translationService.getProductSharingCSVTemplatesText() }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <button type="button" (click)="goToCreate()">
    {{ translationService.getCreateTemplateText() }}
  </button>

  <app-product-sharing-template-list></app-product-sharing-template-list>
</mat-expansion-panel>
